// @flow
import {
    CHANGE_SELECTED_DAY,
    CHANGE_ZOOM_LEVEL,
    CHANGE_EVENTS_CURRENT_DAY,
    LOAD_PAGE,
    PAGE_READY,
    RECEIVE_EVENTS,
    UNLOAD_PAGE
} from './constants';

import { createAction } from 'redux-actions';

export const changeSelectedDay = createAction(CHANGE_SELECTED_DAY);

export const changeZoomLevel = createAction(CHANGE_ZOOM_LEVEL);

export const changeEventsCurrentDay = createAction(CHANGE_EVENTS_CURRENT_DAY);

export const loadPage = createAction(LOAD_PAGE, (id, now, timezone) => ({ id, now, timezone }));

export const pageReady = createAction(PAGE_READY);

export const receiveEvents = createAction(RECEIVE_EVENTS, (day, data, id) => ({ day, data, id }));

export const unloadPage = createAction(UNLOAD_PAGE);



// WEBPACK FOOTER //
// ./src/core/state/products/contact-sensor/actions.js